<div class="card h-full flex flex-col relative">
  <div class="border-b px-4 py-2 flex-none flex items-center">
    <mat-icon
      svgIcon="mat:drag_indicator"
      class="icon-sm cursor-move mr-2 slc-color-brand"
      cdkDragHandle
    ></mat-icon>

    <h2 class="title flex-auto" [class.hidden]="!card()?.titulo">
      {{ card()?.titulo }}
    </h2>

    <!-- Fullscreen -->
    @if(fullScreenHabilitado()) {
    <button
      class="ml-4 flex-none"
      mat-icon-button
      matTooltip="Retrair"
      type="button"
      (click)="alternarFullscreen.emit()"
    >
      <mat-icon svgIcon="mat:close_fullscreen"></mat-icon>
    </button>

    } @else {

    <button
      (click)="alternarFullscreen.emit()"
      class="flex-none slc-expandir"
      mat-icon-button
      matTooltip="Expandir"
      type="button"
    >
      <mat-icon svgIcon="mat:open_in_full"></mat-icon>
    </button>
    }

    <button
      class="flex-none slc-mais-opcoes"
      mat-icon-button
      matTooltip="Mais Opções"
      type="button"
      [matMenuTriggerFor]="maisOpcoesMenu"
    >
      <mat-icon svgIcon="mat:more_vert"></mat-icon>
    </button>
  </div>

  @if (options() && series()) {
  <vex-chart
    [options]="options()!"
    [series]="series()!"
    class="flex-auto"
  ></vex-chart>
  } @else { @if (card()?.tipo === tipoCard.GRAFICO_PIZZA) {
  <ng-container *ngTemplateOutlet="pizzaSkeleton"></ng-container>
  } @else {
  <ng-container *ngTemplateOutlet="chartSkeleton"></ng-container>
  } }
</div>

<mat-menu #maisOpcoesMenu="matMenu">
  <button mat-menu-item (click)="onOcultarCard()">
    <mat-icon svgIcon="mat:visibility_off"></mat-icon>
    <span>Ocultar Card</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="dadosMenu">
    <mat-icon svgIcon="mat:storage"></mat-icon>
    <span>Dados</span>
  </button>
</mat-menu>

<mat-menu #dadosMenu>
  <mat-checkbox
    class="mat-mdc-menu-item slc-checkbox-brand"
    [checked]="origemDados()?.venda"
    (change)="
      origemDados.set({
        venda: $event.checked,
        historico: origemDados()?.historico || false
      })
    "
    >Vendas em aberto</mat-checkbox
  >
  <mat-checkbox
    class="mat-mdc-menu-item slc-checkbox-brand"
    [checked]="origemDados()?.historico"
    (change)="
      origemDados.set({
        venda: origemDados()?.venda || false,
        historico: $event.checked
      })
    "
    >Vendas histórico</mat-checkbox
  >
</mat-menu>

<ng-template #chartSkeleton>
  <div class="animate-pulse flex-1 mx-4 mb-4 flex flex-col relative">
    <svg
      class="absolute inset-0"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <g fill="var(--color-slate-400)">
        <g>
          <rect x="0" y="3.5%" width="8%" height="3%" rx="1%"></rect>
          <rect x="0" y="23.5%" width="8%" height="3%" rx="1%"></rect>
          <rect x="0" y="43.5%" width="8%" height="3%" rx="1%"></rect>
          <rect x="0" y="63.5%" width="8%" height="3%" rx="1%"></rect>
          <rect x="0" y="83.5%" width="8%" height="3%" rx="1%"></rect>
        </g>
        <g stroke="var(--color-slate-200)">
          <line x1="10%" y1="5%" x2="100%" y2="5%"></line>
          <line x1="10%" y1="25%" x2="100%" y2="25%"></line>
          <line x1="10%" y1="45%" x2="100%" y2="45%"></line>
          <line x1="10%" y1="65%" x2="100%" y2="65%"></line>
          <line x1="10%" y1="85%" x2="100%" y2="85%"></line>
        </g>
        <g>
          @if (card()?.tipo === tipoCard.GRAFICO_LINHA) {
          <g stroke-width="1.3" fill="none" stroke="var(--color-slate-400)">
            <path
              d="M 11 23 L 33.5 55 47.5 48 61.5 50 75.5 40 89.5 33"
              opacity="1"
            />
            <path
              d="M 11 48 L 33.5 59 47.5 55 61.5 43 75.5 32 89.5 12"
              opacity="0.8"
            />
            <path
              d="M 11 76 L 33.5 75 47.5 64 61.5 66 75.5 56 89.5 50"
              opacity="0.6"
            />
          </g>
          } @else {
          <g>
            <rect x="15%" y="28%" width="3%" height="57%" opacity="1"></rect>
            <rect x="18%" y="49%" width="3%" height="36%" opacity="0.8"></rect>
            <rect x="21%" y="80%" width="3%" height="5%" opacity="0.6"></rect>
          </g>
          <g>
            <rect x="29%" y="75%" width="3%" height="10%" opacity="1"></rect>
            <rect x="32%" y="7%" width="3%" height="78%" opacity="0.8"></rect>
            <rect x="35%" y="45%" width="3%" height="40%" opacity="0.6"></rect>
          </g>
          <g>
            <rect x="43%" y="60%" width="3%" height="25%" opacity="1"></rect>
            <rect x="46%" y="82%" width="3%" height="3%" opacity="0.8"></rect>
            <rect x="49%" y="73%" width="3%" height="12%" opacity="0.6"></rect>
          </g>
          <g>
            <rect x="57%" y="58%" width="3%" height="27%" opacity="1"></rect>
            <rect x="60%" y="31%" width="3%" height="54%" opacity="0.8"></rect>
            <rect x="63%" y="55%" width="3%" height="30%" opacity="0.6"></rect>
          </g>
          <g>
            <rect x="71%" y="70%" width="3%" height="15%" opacity="1"></rect>
            <rect x="74%" y="60%" width="3%" height="25%" opacity="0.8"></rect>
            <rect x="77%" y="55%" width="3%" height="30%" opacity="0.6"></rect>
          </g>
          <g>
            <rect x="85%" y="48%" width="3%" height="37%" opacity="1"></rect>
            <rect x="88%" y="58%" width="3%" height="27%" opacity="0.8"></rect>
            <rect x="91%" y="5%" width="3%" height="80%" opacity="0.6"></rect>
          </g>
          }
        </g>
        <g>
          <rect x="15%" y="90%" width="9%" height="3%" rx="1%"></rect>
          <rect x="29%" y="90%" width="9%" height="3%" rx="1%"></rect>
          <rect x="43%" y="90%" width="9%" height="3%" rx="1%"></rect>
          <rect x="57%" y="90%" width="9%" height="3%" rx="1%"></rect>
          <rect x="71%" y="90%" width="9%" height="3%" rx="1%"></rect>
          <rect x="85%" y="90%" width="9%" height="3%" rx="1%"></rect>
        </g>
        <g>
          <rect x="8%" y="96%" width="25%" height="3%" rx="1%"></rect>
          <rect x="38%" y="96%" width="25%" height="3%" rx="1%"></rect>
          <rect x="68%" y="96%" width="25%" height="3%" rx="1%"></rect>
        </g>
      </g>
    </svg>
  </div>
</ng-template>

<ng-template #pizzaSkeleton>
  <div class="animate-pulse flex-1 mx-4 mb-4 flex flex-col relative">
    <svg
      class="absolute inset-0 right-10"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
    >
      <g fill="var(--color-slate-400)">
        <circle cx="46" cy="52" r="46" />
        <circle
          cx="46"
          cy="52"
          r="23"
          fill="transparent"
          stroke="var(--color-slate-300)"
          stroke-width="46.5"
          stroke-dasharray="calc(0.36 * 3.142 * 23) calc(2 * 3.142 * 23)"
          transform="rotate(-90 46 52)"
        />
        <circle
          cx="46"
          cy="52"
          r="23"
          fill="transparent"
          stroke="var(--color-slate-200)"
          stroke-width="46.5"
          stroke-dasharray="calc(0.5 * 3.142 * 23) calc(2 * 3.142 * 23)"
          transform="rotate(-26 45 52)"
        />
      </g>
    </svg>
    <div
      class="absolute inset-y-0 right-0 w-10 flex flex-col gap-2 mt-8 justify-start"
    >
      <div class="bg-slate-400 h-4 rounded"></div>
      <div class="bg-slate-300 h-4 rounded"></div>
      <div class="bg-slate-200 h-4 rounded"></div>
    </div>
  </div>
</ng-template>
